import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import LoadButton from "../../../Common/LoadButton";

import ModalGenericPostCancelContainer from "../../../Common/ModalGenericPostCancelContainer";

import { getMiljogebyr as getMiljogebyrAction } from "../../../../actions/miljogebyrerActions";
import {
  postMiljogebyrEttersendelsebrev as postMiljogebyrEttersendelsebrevAction,
  getMiljogebyrEttersendelser as getMiljogebyrEttersendelserAction,
} from "../../../../actions/miljogebyrEttersendelserActions";
import { getMiljoEttersendelserEttersendelsebrevPdf as getMiljoEttersendelserEttersendelsebrevPdfAction } from "../../../../actions/miljoEttersendelsebrevActions";

export default function SendTilSvarUtContainer({
  latestEttersendelseId,
  reloadHistorikk,
  loadButtonStyle = { marginLeft: "20px" },
}) {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const dispatch = useDispatch();

  const [showSendTilSvarUtSpinner, setShowSendTilSvarUtSpinner] =
    useState(false);

  const getMiljogebyr = (id) => dispatch(getMiljogebyrAction(id));
  const postMiljogebyrEttersendelsebrev = (id) =>
    dispatch(postMiljogebyrEttersendelsebrevAction(id));
  const getMiljogebyrEttersendelser = (id) =>
    dispatch(getMiljogebyrEttersendelserAction(id));

  const handleApiCall = async (ettersendelseId) => {
    setShowSendTilSvarUtSpinner(true);
    return postMiljogebyrEttersendelsebrev(ettersendelseId)
      .then(() => {
        setShowSendTilSvarUtSpinner(false);
        getMiljogebyr(miljogebyr.id);
        getMiljogebyrEttersendelser(miljogebyr.id);
        reloadHistorikk();
        return Promise.resolve();
      })
      .catch((error) => {
        setShowSendTilSvarUtSpinner(false);
        return Promise.reject(error);
      });
  };

  const showNoFolgebrevWarning = () =>
    (!miljogebyr.folgebrevId || miljogebyr.folgebrevId === 1) &&
    ((miljogebyr.overtredelse1 &&
      (miljogebyr.overtredelse1.id === 48 ||
        miljogebyr.overtredelse1.id === 66)) ||
      (miljogebyr.overtredelse2 &&
        (miljogebyr.overtredelse2.id === 48 ||
          miljogebyr.overtredelse2.id === 66)) ||
      (miljogebyr.overtredelse3 &&
        (miljogebyr.overtredelse3.id === 48 ||
          miljogebyr.overtredelse3.id === 66)));

  if (
    latestEttersendelseId &&
    miljogebyr.isTilEttersendelse &&
    !miljogebyr.isMakulert &&
    !miljogebyr.isBetalt
  ) {
    return (
      <>
        <ModalGenericPostCancelContainer
          id={latestEttersendelseId}
          submitButtonText="Send til Svar ut"
          submittingButtonText="Sender til Svar ut..."
          successPostCallFlashMessage="Ettersendelsebrev generert"
          errorPostCallFlashMessage="Ettersendelsebrev ble ikke generert"
          handleApiCall={handleApiCall}
          modalTitle={`Send miljøgebyr ${miljogebyr.ileggelsesnummer} til Svar ut`}
          submitButtonDisabled={showSendTilSvarUtSpinner}
          showSubmitSpinner={showSendTilSvarUtSpinner}
          openModalComponentFunction={(props) => (
            <LoadButton
              isLoading={showSendTilSvarUtSpinner}
              buttonProps={{
                className: "btn btn-bym-standard",
                style: loadButtonStyle,
                onClick: props.openModal,
                disabled: showSendTilSvarUtSpinner,
              }}
              spinnerProps={{ pColor: "#ffffff", sColor: "#4d4d4d" }}
            >
              Send til Svar ut
            </LoadButton>
          )}
        >
          {showNoFolgebrevWarning() && (
            <p className="error">
              Du er i ferd med å sende et ettersendelsesbrev uten følgebrev. Er
              du sikker på at du fortsatt vil sende ettersendelsesbrevet?
            </p>
          )}
          <p>
            {`Ønsker du å sende et ettersendelsesbrev for miljøgebyr med ileggelsesnummer ${miljogebyr.ileggelsesnummer} til Svar ut?`}
          </p>
        </ModalGenericPostCancelContainer>
      </>
    );
  }
  return <span />;
}

SendTilSvarUtContainer.propTypes = {
  latestEttersendelseId: PropTypes.string,
  reloadHistorikk: PropTypes.func,
  loadButtonStyle: PropTypes.object,
};
